import { jsPDF } from "jspdf";
import moment from "moment";
import { serviceTypes, TypePaiment } from "../Constants/types";
import format_number from "./number_formatter";
import { arabicFont } from "../Constants/arabic";

export const numberToLetter = (sum) => {
  if (sum === 0) return "zéro dinars tunisien";

  const moinsVingt = [
    "un",
    "deux",
    "trois",
    "quatre",
    "cinq",
    "six",
    "sept",
    "huit",
    "neuf",
    "dix",
    "onze",
    "douze",
    "treize",
    "quatorze",
    "quinze",
    "seize",
    "dix-sept",
    "dix-huit",
    "dix-neuf",
  ];
  const dizaines = [
    "vingt",
    "trente",
    "quarante",
    "cinquante",
    "soixante",
    "soixante-dix",
    "quatre-vingts",
    "quatre-vingt-dix",
  ];
  const milliers = ["", "mille", "million", "milliard"];

  const valueCheck = (n) => {
    if (n === 0) return "";
    else if (n < 20) return moinsVingt[n - 1];
    else if (n < 100)
      return (
        dizaines[Math.floor(n / 10) - 2] +
        (n % 10 === 1 ? " et un" : n % 10 !== 0 ? " " + valueCheck(n % 10) : "")
      );
    else
      return (
        (Math.floor(n / 100) > 1
          ? moinsVingt[Math.floor(n / 100) - 1] + " "
          : "") +
        "cent" +
        (n % 100 !== 0 ? " " + valueCheck(n % 100) : "")
      );
  };

  let [integerPart, decimalPart] = sum.toString().split(".");

  integerPart = parseInt(integerPart, 10);

  let decimalSomme = decimalPart ? decimalPart.padEnd(3, "0") : "000";
  let decimalValue = parseInt(decimalSomme, 10);

  let resultat = "";
  let i = 0;

  while (integerPart > 0) {
    if (integerPart % 1000 !== 0) {
      resultat =
        valueCheck(integerPart % 1000) + " " + milliers[i] + " " + resultat;
    }
    integerPart = Math.floor(integerPart / 1000);
    i++;
  }

  resultat = resultat.trim();
  let finalResult = resultat ? resultat + " dinars" : "";

  if (decimalValue > 0) {
    let decimalText = valueCheck(decimalValue) + " millimes";
    finalResult += finalResult ? " et " + decimalText : decimalText;
  } else {
    finalResult += " tunisien";
  }

  return finalResult.trim();
};

export const showReceipt = (
  receiptData,
  operations,
  clientsB2C,
  clients,
  referrersData
) => {
  const getDesignationById = (id) => {
    const operation = operations.find((elem) => elem.id === id);
    return operation ? operation.designation : "...";
  };

  const getServiceById = (id) => {
    const operation = serviceTypes.find((elem) => elem.value === id);
    return operation ? operation.label : "...";
  };

  const doc = new jsPDF();
  const pageWidth = 210;

  const img = new Image();
  img.src = "/logo.png";
  img.onload = () => {
    const x = 15;
    const y = 10;
    const width = 90;
    const height = 30;

    // doc.addImage(img, "PNG", x, y, width, height);

    // doc.setFontSize(14);
    // doc.setFont("Arial", "bold");
    // doc.text("STE KOUNOUZ TOURISM SUARL", 20, 50);

    doc.setFontSize(10);
    doc.setFont("Arial", "small");
    // doc.text(
    //   `Société Unipersonnelle à responsabilité limitée\n` +
    //     `Résidente au capital de 700020.000.000 dinars\n` +
    //     `Siège social : Rue Italie Immeuble Bouchra – 4000 - Sousse\n` +
    //     `M.F. : 1214866P/A/M/000 – IU-RNE : 1214866P`,
    //   20,
    //   55
    // );

    doc.setFont("Arial", "bold");
    doc.text(
      `DATE LE: ${moment(receiptData?.date).format("DD-MM-yyyy")}`,
      155,
      75
    );

    doc.setFontSize(18);
    doc.setFont("times", "bold");
    let currentY = 100;

    const textReceipt =
      receiptData.debit !== 0 ? "Reçu de paiement n°" : "Note de frais n°";
    const title = `${textReceipt}: ${receiptData?.nbePiece || "-"}`;
    const textWidth = doc.getTextWidth(title);
    const textX = (pageWidth - textWidth) / 2;
    doc.text(title, textX, currentY);

    currentY += 20;
    doc.setFontSize(12);

    if (receiptData.debit !== 0) {
      doc.setFontSize(12);
      doc.setFont("Arial");
      if (receiptData?.infosB2C?.fullName) {
        doc.text(
          `Reçu de Monsieur, Madame : ${receiptData?.infosB2C?.fullName}`,
          20,
          currentY
        );
        currentY += 5;
        if (receiptData.clientId) {
          doc.setFont("Arial", "normal");
          const selected = clients.find(
            (client) => client.id === receiptData.clientId
          );
          doc.text(`${selected?.name || ""}`, 25, currentY);
          currentY += 5;
        }
        doc.setFont("Arial", "normal");
        doc.text(
          `- N° de passeport : ${receiptData?.infosB2C?.passportNumber || ""}`,
          25,
          currentY
        );
        currentY += 5;
        doc.text(
          `- N° de téléphone : ${receiptData?.infosB2C?.phone || ""}`,
          25,
          currentY
        );
        currentY += 10;
      } else {
        doc.addFileToVFS("Amiri-Regular.ttf", arabicFont);
        doc.addFont("Amiri-Regular.ttf", "Amiri", "normal");
        doc.setFont("Amiri", "normal");
        if (receiptData.clientId) {
          doc.setFont("Arial", "normal");
          const selected = clients.find(
            (client) => client.id === receiptData.clientId
          );
          const arabicServiceText = `Reçu de Monsieur, Madame : ${selected?.name}`;
          doc.text(arabicServiceText, 20, currentY);
          currentY += 5;
        } else {
          const arabicServiceText = `Reçu de Monsieur, Madame : ${receiptData?.representative}`;
          doc.text(arabicServiceText, 20, currentY);
          currentY += 5;
          if (receiptData.clientId) {
            doc.setFont("Arial", "normal");
            const selected = clients.find(
              (client) => client.id === receiptData.clientId
            );
            doc.text(`${selected?.name || ""}`, 25, currentY);
            currentY += 5;
          }
        }
      }
    }

    if (receiptData.credit !== 0) {
      doc.addFileToVFS("Amiri-Regular.ttf", arabicFont);
      doc.addFont("Amiri-Regular.ttf", "Amiri", "normal");
      doc.setFont("Amiri", "normal");
      if (receiptData.referrerId) {
        console.log(referrersData, "referrersData");
        const selected = referrersData?.find(
          (referrer) => referrer.id === receiptData.referrerId
        );
        const arabicServiceText = `Frais de Monsieur, Madame : ${selected?.name}`;
        doc.text(arabicServiceText, 20, currentY);
        currentY += 5;
      } else if (receiptData?.clientId) {
        const selected = clients.find(
          (client) => client.id === receiptData.clientId
        );
        const arabicServiceText = `Frais de Monsieur, Madame : ${selected?.name}`;
        doc.text(arabicServiceText, 20, currentY);
        currentY += 5;
      } else {
        const arabicServiceText = `Frais de Monsieur, Madame : ${receiptData?.representative}`;
        doc.text(arabicServiceText, 20, currentY);
        currentY += 5;
      }

      if (receiptData?.clientId) {
        doc.setFont("Arial", "normal");
        const selected = clients.find(
          (client) => client.id === receiptData.clientId
        );
        doc.text(`- ${selected?.name || ""}`, 25, currentY);
        currentY += 5;
      }
    }

    if (receiptData.paidFor && receiptData.paidFor.length > 0) {
      doc.setFontSize(12);
      doc.setFont("Arial", "bold");
      doc.text(`Conjoint :`, 20, currentY);
      currentY += 5;

      doc.setFont("Arial", "normal");
      receiptData.paidFor.forEach((item, index) => {
        doc.text(`Conjoint ${index + 1} :`, 25, currentY);
        currentY += 5;

        const selected = clientsB2C?.find(
          (client) => client.id === item.clientId
        );
        doc.text(`- Nom : ${selected?.fullName || "-"}`, 25, currentY);
        currentY += 5;
        doc.text(`- N° de téléphone : ${selected?.phone || "-"}`, 25, currentY);
        currentY += 5;
        doc.text(
          `- N° de Passport : ${selected?.passportNumber || "-"}`,
          25,
          currentY
        );
        currentY += 10;
      });
    }

    doc.setFont("Arial", "normal");
    doc.text(
      `- La somme de : ${numberToLetter(
        receiptData.debit !== 0 ? receiptData.debit : receiptData.credit
      )} (${
        receiptData.debit !== 0
          ? format_number(receiptData.debit)
          : format_number(receiptData.credit)
      } DT)`,
      25,
      currentY
    );
    currentY += 5;
    doc.setFont("Arial", "normal");

    const payment =
      TypePaiment.find((p) => p.value === receiptData.paiment)?.label ||
      "Autres";
    doc.text(`- Type de paiement : ${payment}`, 25, currentY);

    currentY += 10;
    doc.setFont("Arial", "bold");
    doc.text("Cette somme a été reçu pour ses services : ", 20, currentY);
    currentY += 5;

    doc.setFont("Arial", "normal");
    doc.text(
      receiptData.operationTypeId
        ? getDesignationById(receiptData.operationTypeId)
        : "-",
      25,
      currentY
    );
    currentY += 5;

    doc.addFileToVFS("Amiri-Regular.ttf", arabicFont);
    doc.addFont("Amiri-Regular.ttf", "Amiri", "normal");
    doc.setFont("Amiri", "normal");

    const serviceText =
      receiptData.service === 7 && receiptData.disponibilityName
        ? `${getServiceById(receiptData.service)} : ${
            receiptData.disponibilityName
          }`
        : getServiceById(receiptData.service);

    const arabicServiceText = `${serviceText}`;

    doc.text(arabicServiceText, 25, currentY);

    currentY += 5;

    doc.text(receiptData.designation || "...", 25, currentY);
    currentY += 25;

    doc.text("Ce reçu confirme que le paiement a été bien fait", 20, currentY);
    currentY += 20;

    doc.text("Signature", 50, currentY);
    currentY += 25;

    doc.setFont("Arial", "normal");
    doc.setFontSize(10);
    const pageHeight = doc.internal.pageSize.height;
    const pageBottomHeight = pageHeight - 10;
    const pageBottom =
      "Adresse : Rue Italie Immeuble Bochra - 4000 SOUSSE. TUNISIE. MF: 1214866P /AM-000";
    const bottomTextWidth = doc.getTextWidth(pageBottom);
    const bottomTextX = (pageWidth - bottomTextWidth) / 2;
    doc.text(pageBottom, bottomTextX, pageBottomHeight);

    const pdfBlob = doc.output("blob");
    const blobUrl = URL.createObjectURL(pdfBlob);
    window.open(blobUrl, "_blank");
  };

  img.onerror = () => {
    console.error("Failed to load image");
  };
};
